import { v4 as uuid } from 'uuid';
import cloneDeep from 'clone-deep';
import { matchesNew } from '@components/bid_request/details/utils/matchesNew';
import { CustomColumnHeader } from 'types';

/**
 * For adding an id field with a new UUID.  This enables copied ids that match new to be replaced easily.
 * @param {CustomColumnHeader[]} objectList List of objects to give
 * @returns {CustomColumnHeader[]} Deep clone of the provided objects with new id attribute.
 */
export const updateNewUUIDs = (
  objectList: CustomColumnHeader[]
): CustomColumnHeader[] =>
  objectList.map(object => {
    const objectId =
      !object.id || matchesNew(object.id) ? `new-${uuid()}` : object.id;

    return { ...cloneDeep(object), id: objectId };
  });
